import {AreaNode, DepartmentNode, EquipmentNode} from '@hconnect/common/types'
import React from 'react'

interface PlantStructureTreePopupWrapperProps {
  nodeType: AreaNode | DepartmentNode | EquipmentNode | null | undefined
  popup: JSX.Element
}

export const PlantStructureTreePopupWrapper: React.FC<PlantStructureTreePopupWrapperProps> = ({
  nodeType,
  popup
}) => {
  return <>{nodeType && popup}</>
}
